import { render } from "./nofunciona.vue?vue&type=template&id=7c2d8c06"
import script from "./nofunciona.vue?vue&type=script&lang=js"
export * from "./nofunciona.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__